import { render, staticRenderFns } from "./priceListMview.vue?vue&type=template&id=7ac0497c&"
import script from "./priceListMview.vue?vue&type=script&lang=js&"
export * from "./priceListMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports